<template>
  <div>
    <HearderTitle :name="title" />
    <div class="personnelFrom">
      <el-form ref="personnelFrom" :rules="rules" :model="personnelFrom" label-width="110px" :inline="true" size="small">
        <p class="title">个人信息</p>
        <el-form-item label="姓名" prop="pername">
          <el-input v-model="personnelFrom.pername"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="personnelFrom.sex">
            <el-radio label="男"></el-radio>
            <el-radio label="女"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="联系方式" prop="contact">
          <el-input v-model="personnelFrom.contact"></el-input>
        </el-form-item>
        <el-form-item label="身份证" prop="cardid">
          <el-input @blur="chenge(personnelFrom.cardid)" v-model="personnelFrom.cardid"></el-input>
        </el-form-item>
        <el-form-item label="生日" prop="birthday">
          <el-date-picker v-model="personnelFrom.birthday" prefix-icon=" " format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"> </el-date-picker>
        </el-form-item>
        <el-form-item label="户籍" prop="province">
          <el-input v-model="personnelFrom.province"></el-input>
        </el-form-item>
        <el-form-item label="户籍所在地" prop="address">
          <el-input v-model="personnelFrom.address"></el-input>
        </el-form-item>
        <el-form-item label="民族" prop="nation">
          <el-input v-model="personnelFrom.nation"></el-input>
        </el-form-item>
        <el-form-item label="学校" prop="school">
          <el-input v-model="personnelFrom.school"></el-input>
        </el-form-item>
        <el-form-item label="学历" prop="edu">
          <el-input v-model="personnelFrom.edu"></el-input>
        </el-form-item>
        <el-form-item label="专业" prop="manjor">
          <el-input v-model="personnelFrom.manjor"></el-input>
        </el-form-item>
        <el-form-item label="婚姻状态" prop="marrage">
          <el-radio-group v-model="personnelFrom.marrage">
            <el-radio label="未婚"></el-radio>
            <el-radio label="已婚"></el-radio>
          </el-radio-group>
        </el-form-item>
        <p class="title">入职信息</p>
        <el-form-item label="所属部门" prop="dep_id">
          <el-select v-model="personnelFrom.dep_id" placeholder="请选择" ref="selectTree" @change="changeDep(personnelFrom.dep_id)">
            <el-option v-for="item in datalist" :key="item.id" :value="item.name" :label="item.name"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="职务" prop="roles">
          <el-select v-model="personnelFrom.roles" placeholder="请选择">
            <el-option v-for="item in childrenData" :key="item.id" :value="item.name" :label="item.name"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="入职时间" prop="inday">
          <el-date-picker v-model="personnelFrom.inday" prefix-icon=" " format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"> </el-date-picker>
        </el-form-item>
        <el-form-item label="面试人" prop="msper">
          <el-input v-model="personnelFrom.msper"></el-input>
        </el-form-item>
        <p class="title">简历图片</p>
        <el-form-item label="备注" prop="moreinfo" class="pics">
          <el-input class="moreinfo" v-model="personnelFrom.moreinfo"></el-input>
        </el-form-item>
        <el-form-item label="面试评价" prop="mspj" class="pics">
          <el-input class="moreinfo" v-model="personnelFrom.mspj"></el-input>
        </el-form-item>
        <el-form-item class="upload pics" label="简历上传" prop="pics">
          <el-input class="moreinfo" :limit="1" readonly v-model="personnelFrom.pics"> </el-input>
          <el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"> 上传 <i class="el-icon-plus avatar-uploader-icon"></i> </el-upload>
        </el-form-item>
        <el-form-item class="upload pics" label="上传照片" prop="perzp">
          <el-input class="moreinfo" readonly v-model="personnelFrom.perzp"> </el-input>
          <el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false" :on-success="handlePerzpSuccess" :before-upload="beforeAvatarUpload"> 上传 <i class="el-icon-plus avatar-uploader-icon"></i> </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button class="lightBlueBtn" type="primary" size="small" @click="seve()">提交</el-button>
          <el-button plain size="small" @click="$refs['personnelFrom'].resetFields()">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import { getDepList } from '@/api/common.js'
  import { addOutsourcing, editOutsourcing, getOutsourcingInfoById } from '@/api/personnelList.js'
  import HearderTitle from '@/components/HearderTitle'
  import { getUserInfoByidNumber } from '@/util/index.js'
  export default {
    data() {
      return {
        personnelFrom: {
          pername: '',
          sex: '',
          contact: '',
          cardid: '',
          birthday: '',
          province: '',
          address: '',
          nation: '',
          school: '',
          edu: '',
          manjor: '',
          marrage: '',
          dep_id: '',
          roles: '',
          inday: '',
          msper: '',
          moreinfo: '',
          mspj: '',
          pics: '',
          perzp: '',
        },
        datalist: [],
        depList: [],
        rules: {
          pername: [{ required: true, message: '姓名不能为空', trigger: 'blur' }],
          sex: [{ required: true, message: '性别不能为空', trigger: 'blur' }],
          contact: [
            { required: true, message: '联系方式不能为空', trigger: 'blur' },
            { pattern: /^1\d{10}$/, message: '请输入正确的手机号', trigger: 'blur' },
          ],
          cardid: [
            { required: true, message: '身份证不能为空', trigger: 'blur' },
            { pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, message: '请输入正确的身份证号', trigger: 'blur' },
          ],
          birthday: [{ required: true, message: '生日不能为空', trigger: 'blur' }],
          province: [{ required: true, message: '户籍不能为空', trigger: 'blur' }],
          // address: [{ required: true, message: '户籍所在地不能为空', trigger: 'blur' }],
          // nation: [{ required: true, message: '民族不能为空', trigger: 'blur' }],
          // school: [{ required: true, message: '学校不能为空', trigger: 'blur' }],
          // edu: [{ required: true, message: '学历不能为空', trigger: 'blur' }],
          // manjor: [{ required: true, message: '专业不能为空', trigger: 'blur' }],
          // marrage: [{ required: true, message: '婚姻状态不能为空', trigger: 'blur' }],
          dep_id: [{ required: true, message: '所属部门不能为空', trigger: 'blur' }],
          roles: [{ required: true, message: '职务不能为空', trigger: 'blur' }],
          inday: [{ required: true, message: '入职时间不能为空', trigger: 'blur' }],
        },
        uploadUrl: '',
        title: '',
        childrenData: [],
        personnelInfo: {},
        id: '',
      }
    },
    async created() {
      let { data } = await getDepList()
      this.depList = data
      data.forEach((v) => {
        if (v.pid === 0) {
          this.datalist.push(v)
        }
      })

      // 获取上传url
      this.uploadUrl = process.env.VUE_APP_API_URL + '/mypub/loaddail?ty=hr'
      // 获取编辑页面id
      if (this.$route.name === 'editOutsourcing') {
        this.title = '编辑外线'
        let id = ''
        if (this.$route.params.id) {
          id = this.$route.params.id
          sessionStorage.setItem('personneId', id)
          // 获取修改数据索引并保存
          sessionStorage.setItem('editDataIndex', this.$route.params.index)
        } else {
          id = JSON.parse(sessionStorage.getItem('personneId'))
        }
        this.id = id
        this.getOutsourcingInfoById(id)
      } else {
        this.title = '添加外线'
      }
    },
    methods: {
      // //节点点击事件
      // handleClickNode(data) {
      //   this.personnelFrom.dep_id = data.name
      //   // 选择器执行完成后，使其失去焦点隐藏下拉框的效果
      //   this.$refs.selectTree.blur()
      // },
      changeDep(val) {
        this.personnelFrom.roles = ''
        this.depList.forEach((v) => {
          if (val == v.name) {
            this.childrenData = v.children
          }
        })
      },
      // 提交
      async seve() {
        this.$refs['personnelFrom'].validate(async (valid) => {
          if (!valid) return
          let res = {}
          if (this.id !== '') {
            let data = { id: this.id, ...this.personnelFrom }
            res = await editOutsourcing(data)
            // 缓存修改的数据
            sessionStorage.setItem('editOutsourcingData', JSON.stringify(data))
          } else {
            res = await addOutsourcing(this.personnelFrom)
          }
          if (res.status !== 200) return this.$message.error('提交失败')
          this.$message.success('提交成功')
          return this.$router.go(-1)
        })
      },
      // 根据id查询人员信息
      async getOutsourcingInfoById(id) {
        let res = await getOutsourcingInfoById({ id })
        this.personnelFrom = res.data
      },
      // 上传简历
      handleAvatarSuccess(res, file) {
        if (res.status !== 200) return this.$message.error('上传失败')
        this.$message.success('上传成功')
        let len = this.personnelFrom.pics.length
        if (len === 0) {
          this.personnelFrom.pics += 'http://yjhr.oss-cn-shenzhen.aliyuncs.com/' + res.url
        } else {
          this.personnelFrom.pics += ',http://yjhr.oss-cn-shenzhen.aliyuncs.com/' + res.url
        }
      },
      // 上传图片
      handlePerzpSuccess(res, file) {
        if (res.status !== 200) return this.$message.error('上传失败')
        this.$message.success('上传成功')
        this.personnelFrom.perzp = 'http://yjhr.oss-cn-shenzhen.aliyuncs.com/' + res.url
      },
      // 上传限制
      beforeAvatarUpload(file) {
        const isJPG = ['image/jpeg', 'image/png']
        const isLt5M = file.size / 1024 / 1024 < 6
        if (!isJPG.includes(file.type)) {
          this.$message.error('上传头像图片只能是JPG或PNG 格式!')
        }
        if (!isLt5M) {
          this.$message.error('上传头像图片大小不能超过 5MB!')
        }
        return isJPG.includes(file.type) && isLt5M
      },
      // 根据身份证号获取信息
      chenge(val) {
        if (!new RegExp(/^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/).test(val)) return
        let { province, birthday, sex } = getUserInfoByidNumber(val)
        this.personnelFrom.sex = sex
        this.personnelFrom.birthday = birthday
        this.personnelFrom.province = province
      },
    },
    watch: {
      'personnelFrom.dep_id': function (val, oldVal) {
        console.log(val, oldVal)
        this.depList.forEach((v) => {
          if (val == v.name) {
            this.childrenData = v.children
          }
        })
      },
    },
    components: { HearderTitle },
  }
</script>

<style lang="less">
  .personnelFrom {
    margin: 0 auto;
    margin-top: 40px;
    width: 976px;
    .title {
      font-size: 14px;
      color: #666666;
      border-left: 3px solid #1f7ac3;
      height: 14px;
      padding-left: 5px;
      line-height: 14px;
      margin-bottom: 5px;
    }
    .el-form-item {
      .el-form-item__label {
        font-size: 12px;
      }
      &:nth-of-type(2n) {
        padding-left: 40px;
      }
      &.pics {
        padding-left: 70px;
      }
      &.upload {
        position: relative;
        .avatar-uploader {
          background-color: #fff;
          position: absolute;
          right: 10px;
          top: 0;
          color: #b3b3b3;
          height: 30px;
          margin-top: 1px;
        }
      }
      &:last-of-type {
        margin-top: 10px;
        display: flex;
        justify-content: center;
        .el-button {
          width: 112px;
          height: 32px;
          padding: 0;
          text-align: center;
          line-height: 32px;
          font-size: 14px;
          margin-right: 20px;
        }
      }
      .el-date-editor.el-input,
      .el-date-editor.el-input__inner,
      .el-input__inner {
        width: 300px;
      }
      .el-date-editor .el-input__inner {
        padding-left: 15px;
      }
      .moreinfo {
        width: 100%;
        .el-input__inner {
          width: 760px;
        }
      }
    }
  }
</style>
